import { requestWithAuthorization } from "./apiRequests";

interface FetchDataForZoomResult {
  status: number;
  data?: any;
  error?: any;
}

export async function fetchPlotData(
  recordingId: string,
  characteristic?: string,
  start?: string,
  end?: string,
  sensorId?: string,
  limit?: number
): Promise<FetchDataForZoomResult> {
  let requestUrl = `${process.env.REACT_APP_API_HOSTNAME}/recordings/plotdata?recordingId=${recordingId}`;
  
  // Add sensorId if provided
  if (sensorId) {
    requestUrl += `&sensorId=${sensorId}`;
  }
  
  if (characteristic) {
    requestUrl += `&characteristic=${characteristic}`;
  }
  
  if (start !== undefined) {
    requestUrl += `&start=${start}`;
  }
  
  if (end !== undefined) {
    requestUrl += `&end=${end}`;
  }
  
  if (limit !== undefined) {
    requestUrl += `&limit=${limit}`;
  }
  try {
    const response = await requestWithAuthorization(requestUrl);
    if (response.status === 200) {
      return { status: response.status, data: response.data };
    } else {
      console.error(response);
      return { status: response.status, error: response.statusText };
    }
  } catch (error) {
    console.error(error);
    return { status: 500, error }; // Generic status code
  }
}
